export const HOST = process.env.REACT_APP_API_URL || "https://ttdk-develop-server.service.makefamousapp.com/"

export const IMAGE_HOST = HOST + 'upload/'

export const VERSION_WEB = process.env.REACT_APP_BUILD_VERSION